




































































import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { validationMixin } from 'vuelidate'
import { email, required } from 'vuelidate/lib/validators'
import { PRIVACY_POLICY_PATH } from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'
import { getProductSpecificationReportApi } from '~/assets/config/api-path'

@Component({
  filters: {
    filterUrl,
  },
  components: {
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentFormTextarea: () => import('~/components/form/textarea.vue'),
    ComponentFormInputText: () => import('~/components/form/input-text.vue'),
    ComponentFormButton: () => import('~/components/form/button.vue'),
  },
  mixins: [validationMixin],
  validations: {
    comment: {
      required,
    },
    email: {
      required,
      email,
    },
  },
})
export default class ComponentProductSpecificationNote extends Vue {
  @Prop({ type: Number, required: true }) readonly productId!: number

  private PRIVACY_POLICY_PATH = PRIVACY_POLICY_PATH
  private isPopupOpen = false
  private isLoading = false
  private isSent = false
  private comment = ''
  private email = ''

  private get payload() {
    return {
      comment: this.comment,
      email: this.email,
      productId: this.productId,
    }
  }

  private async send() {
    this.$v.$touch()
    if (this.$v.$invalid || this.isLoading) {
      return
    }

    this.isLoading = true
    await this.$axios.$post(
      getProductSpecificationReportApi(this.productId),
      this.payload
    )
    this.isSent = true
    this.isLoading = false
  }
}
